import { FC, memo } from 'react'
import { TrustItem, IconWrapper, TextContent, Label, DesktopIconWrapper, MobileIconWrapper } from './styles'
import NextImage from '../next-image'
import { useTranslation, useLocale } from '../../../hooks/locale'

export type TrustBarItemId = 'trustpilot' | 'accommodations' | 'bookings' | 'recommendations' | 'legacy'

export interface TrustBarItemData {
    id: TrustBarItemId
    icon: any
    mobileIcon?: any
    translationKey: string
    number: number | null
    isImage?: boolean
}

interface TrustBarItemProps {
    item: TrustBarItemData
}

const TrustBarItem: FC<TrustBarItemProps> = ({ item }) => {
    const { t } = useTranslation()
    const { locale } = useLocale()
    const { id, icon, mobileIcon, translationKey, number, isImage } = item

    if (isImage) {
        return (
            <TrustItem $isTrustPilotLogo>
                <DesktopIconWrapper $isTrustPilotLogo>
                    <NextImage src={icon} alt={id} objectFit="contain" sizes="7rem" />
                </DesktopIconWrapper>
                {mobileIcon && (
                    <MobileIconWrapper $isTrustPilotLogo>
                        <NextImage src={mobileIcon} alt={id} objectFit="cover" sizes="7rem" />
                    </MobileIconWrapper>
                )}
            </TrustItem>
        )
    }

    const formattedNumber = number?.toLocaleString(locale)

    const IconComponent = icon
    const text = t(translationKey, { count: formattedNumber ?? '0' }) ?? ''

    return (
        <TrustItem>
            <IconWrapper>
                <IconComponent />
            </IconWrapper>
            <TextContent>
                <Label>{text}</Label>
            </TextContent>
        </TrustItem>
    )
}

export default memo(TrustBarItem)
